// Copyright 2019 Ryan Zeigler
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { LinkedList } from "../listc";
class RuntimeImpl {
    constructor() {
        this.running = false;
        this.array = new LinkedList();
        this.isRunning = () => this.running;
    }
    run() {
        var _a, _b;
        this.running = true;
        let next = (_a = this.array.deleteHead()) === null || _a === void 0 ? void 0 : _a.value;
        while (next) {
            next[0](next[1]);
            next = (_b = this.array.deleteHead()) === null || _b === void 0 ? void 0 : _b.value;
        }
        this.running = false;
    }
    dispatch(thunk, a) {
        this.array.append([thunk, a]);
        if (!this.running) {
            this.run();
        }
    }
    dispatchLater(thunk, a, ms) {
        const handle = setTimeout(() => this.dispatch(thunk, a), ms);
        return (cb) => {
            clearTimeout(handle);
            cb();
        };
    }
}
export const defaultRuntime = new RuntimeImpl();
